import { createContext, useContext, useEffect, useState } from 'react';

interface GTMContextType {
  tagId: string | null;
  setTagId: (id: string) => void;
  addDataLayer: (data: any) => void;
  setBrandDataLayer: (brand_name: string) => void;
  setShopDataLayer: (shop_name: string, shop_id: number) => void;
  setOrderTypeDataLayer: (order_type: string) => void;
}

const GTMContext = createContext<GTMContextType>({
  tagId: null,
  setTagId: () => {},
  addDataLayer: () => {},
  setBrandDataLayer: () => {},
  setShopDataLayer: () => {},
  setOrderTypeDataLayer: () => {},
});
const GTM_ID = import.meta.env.VITE_GLOBAL_TAG_ID;

export const useGTM = () => useContext(GTMContext);

const loadGtmScript = (gtmId: string) => {
  console.log('Cargando GTM con ID:', gtmId);
  if (document.getElementById(`${gtmId}`)) return; // Evita duplicados

  const script = document.createElement('script');
  script.async = true;
  script.id = `${gtmId}`;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gtmId}`;
  document.head.appendChild(script);

  const scriptInline = document.createElement('script');
  scriptInline.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${gtmId}');
  `;
  document.head.appendChild(scriptInline);
};

export const GTMProvider = ({ children }: { children: React.ReactNode }) => {
  // Ensure dataLayer exists immediately on mount
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
    }
  }, []);
  const [tagId, setTagId] = useState<string | null>(null);
  useEffect(() => {
    if (GTM_ID) {
      //  loadGtmScript(GTM_ID);
    }
  }, [GTM_ID]); // Solo ejecuta GTM cuando `GTM_ID` cambia y tiene un valor
  useEffect(() => {
    if (tagId) {
      //setBrandTagDataLayer(tagId); // Establece un valor por defecto para brand_tag
      console.log('Cargando GTM con tagId:', tagId);
      loadGtmScript(tagId);
    }
  }, [tagId]); // Solo ejecuta GTM cuando `tagId` cambia y tiene un valor

  const addDataLayer = (data: any) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  };

  const setBrandDataLayer = (brand_name: string) => {
    console.log('setBrandDataLayer', brand_name);
    addDataLayer({ event: 'set_brand', brand: brand_name, order_type: 'default', shop: 'default' });
    // loadGtmScript(GTM_ID); // luego cargas GTM
  };

  const setShopDataLayer = (shop_name: string, shop_id: number) => {
    console.log('setShopDataLayer', shop_name, shop_id);
    addDataLayer({event: 'set_brand', shop: shop_name + '-' + shop_id });
  };

  const setOrderTypeDataLayer = (order_type: string) => {
    console.log('setOrderTypeDataLayer', order_type);
    addDataLayer({ order_type: order_type });
  };
  const setBrandTagDataLayer = (brand_tag: string) => {
    console.log('setBrandTagDataLayer', brand_tag);

    addDataLayer({ brand_tag: brand_tag });
  };

  return (
    <GTMContext.Provider
      value={{
        tagId,
        setTagId,
        addDataLayer,
        setBrandDataLayer,
        setShopDataLayer,
        setOrderTypeDataLayer,
      }}
    >
      {children}
    </GTMContext.Provider>
  );
};
